<!-- Register route: path: '/org/:sub_level/:id/fund-collection/:type/book-takeback', component: BookTakeBack -->
<template>
    <div class="section text-center mt-4" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <template v-else>
        <!-- Step 1: Instructions gate -->
        <template v-if="step === 'instructions'">
            <div class="section pt-2">
                <div class="btb-hero">
                    <div class="btb-hero-icon"><ion-icon name="reader-outline"></ion-icon></div>
                    <h3 class="btb-hero-title mal-text">ബുക്ക് തിരിച്ചെടുക്കൽ</h3>
                </div>
            </div>
            <div class="section pt-0 mt-2">
                <div class="btb-card">
                    <div class="btb-instructions mal-text" v-html="instructions"></div>
                    <label class="btb-agree-row">
                        <input type="checkbox" v-model="agreeChecked" />
                        <span class="mal-text">ഞാൻ ഇത് വായിച്ചു</span>
                    </label>
                    <button type="button" class="btn btn-primary btn-block btn-lg mt-2" :disabled="!agreeChecked"
                        @click="agreeAndContinue">
                        തുടരുക
                    </button>
                </div>
            </div>
        </template>

        <!-- Request Share Fund Modal -->
        <div class="modal fade action-sheet" id="requestShareFundModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mal-text">മണ്ഡലത്തിൽ നിന്ന് വിഹിതം റിക്വസ്റ്റ് ചെയ്യുക</h5>
                    </div>
                    <div class="modal-body">
                        <div class="action-sheet-content">
                            <div class="input-wrapper">
                                <label class="label" for="request_share_amount"><span>തുക</span></label>
                                <input type="number" id="request_share_amount" class="form-control" v-model="requestShareAmount" placeholder="₹0.00">
                            </div>
                            <div class="input-wrapper mt-2">
                                <label class="label" for="request_share_reason"><span>കാരണം <em>(optional)</em></span></label>
                                <input type="text" id="request_share_reason" class="form-control" v-model="requestShareReason" placeholder="Reason">
                            </div>
                            <div class="mt-2">
                                <label class="label"><span>പണം ലഭിക്കേണ്ടത്</span></label>
                                <div style="display:flex;gap:8px;">
                                    <button type="button" class="btn btn-sm" :class="requestSharePaymentMethod === 'upi' ? 'btn-primary' : 'btn-outline-secondary'" @click="requestSharePaymentMethod = 'upi'">UPI</button>
                                    <button type="button" class="btn btn-sm" :class="requestSharePaymentMethod === 'bank' ? 'btn-primary' : 'btn-outline-secondary'" @click="requestSharePaymentMethod = 'bank'">Bank Account</button>
                                </div>
                            </div>
                            <template v-if="requestSharePaymentMethod === 'upi'">
                                <div class="input-wrapper mt-2">
                                    <label class="label" for="request_share_upi"><span>UPI ഐഡി <em>(optional)</em></span></label>
                                    <input type="text" id="request_share_upi" class="form-control" v-model="requestShareUpiId" placeholder="name@bank">
                                </div>
                                <p class="mal-text" style="font-size:12px;color:#6c757d;margin:8px 0 0;">അല്ലെങ്കിൽ ഗൂഗിൾ പേ വഴി:</p>
                                <div class="input-wrapper mt-2">
                                    <label class="label" for="request_share_gpay_mobile"><span>ഗൂഗിൾ പേ മൊബൈൽ നമ്പർ</span></label>
                                    <input type="text" id="request_share_gpay_mobile" class="form-control" v-model="requestShareGpayMobile" placeholder="Mobile number">
                                </div>
                                <div class="input-wrapper mt-2">
                                    <label class="label" for="request_share_gpay_name"><span>ഗൂഗിൾ പേ അക്കൗണ്ട് ഹോൾഡറുടെ പേര്</span></label>
                                    <input type="text" id="request_share_gpay_name" class="form-control" v-model="requestShareGpayName" placeholder="Account holder name">
                                </div>
                            </template>
                            <template v-else>
                                <div class="input-wrapper mt-2">
                                    <label class="label" for="request_share_holder"><span>അക്കൗണ്ട് ഹോൾഡറുടെ പേര്</span></label>
                                    <input type="text" id="request_share_holder" class="form-control" v-model="requestShareAccountHolderName" placeholder="Account holder name">
                                </div>
                                <div class="input-wrapper mt-2">
                                    <label class="label" for="request_share_account"><span>അക്കൗണ്ട് നമ്പർ</span></label>
                                    <input type="text" id="request_share_account" class="form-control" v-model="requestShareAccountNumber" placeholder="Account number">
                                </div>
                                <div class="input-wrapper mt-2">
                                    <label class="label" for="request_share_ifsc"><span>IFSC കോഡ്</span></label>
                                    <input type="text" id="request_share_ifsc" class="form-control" v-model="requestShareIfscCode" placeholder="IFSC code">
                                </div>
                            </template>
                            <p class="error-feedback" v-if="requestShareMsg">{{ requestShareMsg }}</p>
                            <button type="button" class="btn btn-primary btn-block btn-lg mt-2" :disabled="requestShareSaving" @click="submitShareFundRequest">
                                <span v-if="requestShareSaving" class="spinner-border spinner-border-sm me-1"></span>
                                റിക്വസ്റ്റ് അയക്കുക
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Payment Proof View Modal -->
        <div class="modal fade action-sheet" id="proofViewModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mal-text">ഇടപാടിന്റെ തെളിവ്</h5>
                    </div>
                    <div class="modal-body text-center">
                        <img :src="viewingProofUrl" style="max-width:100%;border-radius:6px;" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Step 2: Unit selection (only when entered from the zone report's single button —
             skipped entirely when opened directly from a unit's own page). -->
        <template v-if="step === 'select-unit'">
            <div class="section pt-2">
                <div class="btb-hero">
                    <h3 class="btb-hero-title mal-text">ബുക്ക് തിരിച്ചെടുക്കൽ</h3>
                    <div class="btb-hero-meta mal-text">യൂണിറ്റ് തിരഞ്ഞെടുക്കുക</div>
                </div>
            </div>

            <div class="section pt-0 mt-2" v-if="unitsLoading">
                <div class="text-center py-3">
                    <div class="spinner-border spinner-border-sm text-primary"></div>
                </div>
            </div>

            <div class="section pt-0 mt-2" v-else-if="!units.length">
                <div class="btb-notice mal-text">ഈ മണ്ഡലത്തിൽ യൂണിറ്റുകൾ ഇല്ല.</div>
            </div>

            <div class="section pt-0 mt-2" v-else>
                <div class="btb-card" style="padding:6px 16px;">
                    <a href="javascript:void(0)" class="btb-unit-row" v-for="unit in units" :key="unit.id"
                        @click="selectUnit(unit)">
                        <span class="mal-text">{{ unit.name }}</span>
                        <span class="btb-unit-books">
                            <ion-icon name="book-outline"></ion-icon> {{ unit.books_count }}
                        </span>
                        <ion-icon name="chevron-forward-outline" class="btb-unit-chevron"></ion-icon>
                    </a>
                </div>
            </div>
        </template>

        <!-- Step 2b: Unit Accounts Inspection — once per unit per session, before book selection -->
        <template v-if="step === 'unit-inspection'">
            <div class="section pt-2">
                <div class="btb-hero">
                    <a href="javascript:void(0)" class="btb-back-link" v-if="needsUnitSelection" @click="backToUnits">
                        <ion-icon name="chevron-back-outline"></ion-icon> യൂണിറ്റ് ലിസ്റ്റ്
                    </a>
                    <h3 class="btb-hero-title mal-text mt-1">യൂണിറ്റ് അക്കൗണ്ട്സ് ഇൻസ്പെക്ഷൻ</h3>
                    <div class="btb-hero-meta mal-text" v-if="context.unit">{{ context.unit.name }}</div>
                </div>
            </div>

            <div class="section pt-0 mt-2" v-if="inspectionLoading">
                <div class="text-center py-3">
                    <div class="spinner-border spinner-border-sm text-primary"></div>
                </div>
            </div>

            <div class="section pt-0 mt-2" v-else>
                <div class="btb-card">
                    <div class="btb-insp-row" v-for="(q, index) in inspectionQuestions" :key="q.key">
                        <div class="btb-insp-q mal-text">{{ index + 1 }}. {{ q.label }}</div>
                        <div class="btb-insp-toggle">
                            <button type="button" class="btb-insp-btn"
                                :class="{ selected: inspectionAnswers[q.key] === true }"
                                @click="inspectionAnswers[q.key] = true">
                                അതെ
                            </button>
                            <button type="button" class="btb-insp-btn btb-insp-btn-no"
                                :class="{ selected: inspectionAnswers[q.key] === false }"
                                @click="inspectionAnswers[q.key] = false">
                                ഇല്ല
                            </button>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-primary btn-block btn-lg mt-3" :disabled="savingInspection"
                    @click="continueFromInspection">
                    <span v-show="savingInspection" class="spinner-border spinner-border-sm me-1"></span>
                    തുടരുക
                </button>
            </div>
        </template>

        <!-- Step 3: Book selection -->
        <template v-if="step === 'select-book'">
            <div class="section pt-2">
                <div class="btb-hero">
                    <a href="javascript:void(0)" class="btb-back-link" v-if="needsUnitSelection" @click="backToUnits">
                        <ion-icon name="chevron-back-outline"></ion-icon> യൂണിറ്റ് ലിസ്റ്റ്
                    </a>
                    <h3 class="btb-hero-title mal-text mt-1">ബുക്ക് തിരിച്ചെടുക്കൽ</h3>
                    <div class="btb-hero-meta mal-text">
                        <span v-if="context.district">{{ context.district.name }}</span>
                        <span v-if="context.zone"> · {{ context.zone.name }}</span>
                        <span v-if="context.unit"> · {{ context.unit.name }}</span>
                    </div>
                </div>
            </div>

            <!-- Youth Dawa Fund settlement report + Share Taken / Request Share Fund — shown
                 right after instructions + Unit Accounts Inspection, before picking a book. Only
                 when opened directly for a unit. -->
            <div class="section pt-0 mt-2" v-if="subLevel === 4 && settlementSheet">
                <div class="consolidation-card consolidation-card-settlement">
                    <div class="cons-header cons-header-static">
                        <span class="cons-title">Consolidation Report</span>
                    </div>
                    <div class="cons-body">
                        <div class="cons-row">
                            <span class="cons-label mal-text"><ion-icon name="wallet-outline" style="color:#1a418c;"></ion-icon> കൈവശമുള്ള ക്യാഷ്</span>
                            <span class="cons-val">₹{{ formatAmt(settlementSheet.cash_received) }}</span>
                        </div>
                        <div class="cons-row">
                            <span class="cons-label mal-text"><ion-icon name="globe-outline" style="color:#16a34a;"></ion-icon> ഓൺലൈൻ / ഓഫീസ് വഴി</span>
                            <span class="cons-val">₹{{ formatAmt(settlementSheet.online_received) }}</span>
                        </div>
                        <div class="cons-row" v-for="share in settlementSheet.shares" :key="share.key">
                            <span class="cons-label mal-text">➖ {{ share.label }} ({{ share.pct }}%)</span>
                            <span class="cons-val">- ₹{{ formatAmt(share.amount) }}</span>
                        </div>
                        <div class="cons-row cons-row-total">
                            <span class="cons-label mal-text">മണ്ഡലത്തിന് നൽകേണ്ട ബാക്കി തുക</span>
                            <span class="cons-val">₹{{ formatAmt(settlementSheet.net_payable) }}</span>
                        </div>
                        <div class="cons-row" v-if="settlementSheet.shortfall > 0" style="color:#c0392b;">
                            <span class="cons-label mal-text">⚠️ വിഹിതത്തിന് ക്യാഷ് തികയുന്നില്ല</span>
                            <span class="cons-val">₹{{ formatAmt(settlementSheet.shortfall) }}</span>
                        </div>
                    </div>
                </div>
                <template v-if="allBooksVerified">
                    <!-- Request already sent, awaiting Zone's review. -->
                    <div class="share-taken-card mt-2 status-pending" v-if="latestShareRequest && latestShareRequest.status === 'pending'">
                        <span class="share-taken-icon"><ion-icon name="time-outline"></ion-icon></span>
                        <span class="ydf-takeback-body">
                            <span class="ydf-takeback-title mal-text">റിക്വസ്റ്റ് അയച്ചു, മണ്ഡലത്തിന്റെ അംഗീകാരത്തിനായി കാത്തിരിക്കുന്നു</span>
                            <span class="ydf-takeback-desc mal-text">₹{{ formatAmt(latestShareRequest.amount) }} &middot; {{ latestShareRequest.created_at }}</span>
                        </span>
                    </div>
                    <!-- Zone approved — waiting on the unit to confirm the money actually arrived. -->
                    <div class="share-taken-card share-taken-card-action mt-2 status-pending" v-else-if="latestShareRequest && latestShareRequest.status === 'approved' && !latestShareRequest.received_status">
                        <div class="share-taken-row">
                            <span class="share-taken-icon"><ion-icon name="checkmark-circle-outline"></ion-icon></span>
                            <span class="ydf-takeback-body">
                                <span class="ydf-takeback-title mal-text">മണ്ഡലം അംഗീകരിച്ചു — ₹{{ formatAmt(latestShareRequest.amount) }} അയച്ചിട്ടുണ്ട്</span>
                                <span class="ydf-takeback-desc mal-text">തുക ലഭിച്ചോ?</span>
                            </span>
                        </div>
                        <div v-if="latestShareRequest.proof_url" style="width:100%;margin:6px 0;">
                            <a v-if="isPdfUrl(latestShareRequest.proof_url)" :href="latestShareRequest.proof_url" target="_blank" class="btn-share-retry mal-text">📄 തെളിവ് കാണുക (PDF)</a>
                            <button v-else type="button" class="btn-share-retry mal-text" @click="openProofView(latestShareRequest.proof_url)">🖼️ തെളിവ് കാണുക</button>
                        </div>
                        <div class="share-taken-actions">
                            <button type="button" class="btn-share-received mal-text" :disabled="receivingSaving" @click="markReceivedAction(true)">
                                <ion-icon name="checkmark-outline"></ion-icon> ലഭിച്ചു
                            </button>
                        </div>
                    </div>
                    <!-- Zone rejected the request — show why, and let the unit try again. -->
                    <div class="share-taken-card share-taken-card-action mt-2 status-rejected" v-else-if="latestShareRequest && latestShareRequest.status === 'rejected'">
                        <div class="share-taken-row">
                            <span class="share-taken-icon"><ion-icon name="close-circle-outline"></ion-icon></span>
                            <span class="ydf-takeback-body">
                                <span class="ydf-takeback-title mal-text">റിക്വസ്റ്റ് നിരസിച്ചു</span>
                                <span class="ydf-takeback-desc mal-text" style="color:#c0392b;" v-if="latestShareRequest.rejection_reason">കാരണം: {{ latestShareRequest.rejection_reason }}</span>
                            </span>
                        </div>
                        <button type="button" class="btn-share-retry mal-text" @click="openRequestShareModal">വീണ്ടും ശ്രമിക്കുക</button>
                    </div>
                    <!-- Cash is short and there's no in-flight/rejected request blocking a new one. -->
                    <button type="button" class="ydf-takeback-btn mt-2" v-else-if="settlementSheet.shortfall > 0 && !moneyEffectivelyReceived" @click="openRequestShareModal">
                        <span class="ydf-takeback-icon"><ion-icon name="cash-outline"></ion-icon></span>
                        <span class="ydf-takeback-body">
                            <span class="ydf-takeback-title mal-text">മണ്ഡലത്തിൽ നിന്ന് വിഹിതം റിക്വസ്റ്റ് ചെയ്യുക</span>
                            <span class="ydf-takeback-desc mal-text">₹{{ settlementSheet.shortfall.toFixed(2) }} കുറവുണ്ട്</span>
                        </span>
                        <ion-icon name="chevron-forward-outline" class="ydf-takeback-chevron"></ion-icon>
                    </button>
                    <!-- Cash is enough (or the requested shortfall has been received) — self-declare
                         "share taken, rest forwarded to Zone", or show its review status (Zone
                         admin accepts/rejects). -->
                    <template v-else>
                        <p class="mal-text mb-1" style="font-size:12px;color:#16a34a;" v-if="moneyEffectivelyReceived && !settlementSheet.share_taken_at">
                            ✓ ₹{{ formatAmt(latestShareRequest.amount) }} മണ്ഡലത്തിൽ നിന്ന് ലഭിച്ചു
                        </p>
                        <div class="share-taken-card mt-2" :class="'status-' + settlementSheet.share_taken_status" v-if="settlementSheet.share_taken_at">
                            <span class="share-taken-icon">
                                <ion-icon v-if="settlementSheet.share_taken_status === 'accepted'" name="checkmark-circle-outline"></ion-icon>
                                <ion-icon v-else-if="settlementSheet.share_taken_status === 'rejected'" name="close-circle-outline"></ion-icon>
                                <ion-icon v-else name="time-outline"></ion-icon>
                            </span>
                            <span class="ydf-takeback-body">
                                <span class="ydf-takeback-title mal-text">
                                    <template v-if="settlementSheet.share_taken_status === 'accepted'">വിഹിതം എടുത്തു, ബാക്കി തുക മണ്ഡലത്തിലേക്ക് അയച്ചു — അംഗീകരിച്ചു</template>
                                    <template v-else-if="settlementSheet.share_taken_status === 'rejected'">നിരസിച്ചു</template>
                                    <template v-else>അവലോകനത്തിലാണ്</template>
                                </span>
                                <span class="ydf-takeback-desc mal-text">{{ settlementSheet.share_taken_by_name }} &middot; {{ settlementSheet.share_taken_at }}</span>
                                <span class="ydf-takeback-desc mal-text" style="color:#c0392b;" v-if="settlementSheet.share_taken_status === 'rejected' && settlementSheet.share_taken_rejection_reason">
                                    കാരണം: {{ settlementSheet.share_taken_rejection_reason }}
                                </span>
                            </span>
                            <button type="button" class="btn btn-sm btn-outline-primary mal-text" v-if="settlementSheet.share_taken_status === 'rejected'" :disabled="shareTakenSaving" @click="markShareTakenAction">വീണ്ടും ശ്രമിക്കുക</button>
                        </div>
                        <button type="button" class="ydf-takeback-btn mt-2" v-else :disabled="shareTakenSaving" @click="markShareTakenAction">
                            <span class="ydf-takeback-icon"><ion-icon name="checkmark-done-outline"></ion-icon></span>
                            <span class="ydf-takeback-body">
                                <span class="ydf-takeback-title mal-text">വിഹിതം എടുത്തു, ബാക്കി തുക മണ്ഡലത്തിലേക്ക് അയച്ചു</span>
                                <span class="ydf-takeback-desc mal-text">ക്യാഷിൽ നിന്ന് വിഹിതം എടുത്ത് ബാക്കി മണ്ഡലത്തിന് കൈമാറിയെങ്കിൽ ഇവിടെ ക്ലിക്ക് ചെയ്യുക</span>
                            </span>
                        </button>
                    </template>
                </template>
                <p class="mal-text mt-2" style="font-size:12px;color:#6c757d;text-align:center;" v-else>
                    എല്ലാ ബുക്കുകളും തിരിച്ചെടുത്തതിനു ശേഷം മാത്രമേ വിഹിതം അയക്കാനോ റിക്വസ്റ്റ് ചെയ്യാനോ കഴിയൂ.
                </p>
            </div>

            <div class="section pt-0 mt-2" v-if="!books.length">
                <div class="btb-notice mal-text">ഈ യൂണിറ്റിന് രസീത് ബുക്കുകൾ ലഭ്യമല്ല.</div>
            </div>

            <div class="section pt-0 mt-2" v-else>
                <div class="btb-book-grid">
                    <div v-for="book in books" :key="book.id" class="btb-book-tile"
                        :class="{ completed: book.taken_back_at, selected: !book.taken_back_at && selectedBook && selectedBook.id === book.id }"
                        @click="onBookTileClick(book)">
                        <ion-icon :name="book.taken_back_at ? 'checkmark-circle' : 'book-outline'"></ion-icon>
                        <span class="btb-book-no">Book {{ book.book_number }}</span>
                        <span class="btb-book-range" v-if="book.receipt_from">{{ book.receipt_from }}–{{ book.receipt_to }}</span>
                        <span class="btb-book-badge btb-book-badge-done" v-if="book.taken_back_at">✓ വെരിഫൈഡ്</span>
                    </div>
                </div>

                <div class="btb-notice btb-notice-warning mal-text mt-2" v-if="selectedBook && !selectedBook.holder_name">
                    ചുമതലപ്പെടുത്തിയ ആളുടെ പേര് രേഖപ്പെടുത്തിയിട്ടില്ല
                </div>

                <button type="button" class="btn btn-primary btn-block btn-lg mt-3" :disabled="!selectedBook || leavesLoading"
                    @click="loadLeaves">
                    <span v-show="leavesLoading" class="spinner-border spinner-border-sm me-1"></span>
                    തുടരുക
                </button>
            </div>
        </template>

        <!-- Step 3: Leaf verification -->
        <template v-if="step === 'verify-leaves'">
            <div class="section pt-2">
                <div class="btb-hero">
                    <a href="javascript:void(0)" class="btb-back-link" @click="backToBooks">
                        <ion-icon name="chevron-back-outline"></ion-icon> ബുക്ക് ലിസ്റ്റ്
                    </a>
                    <h3 class="btb-hero-title mal-text mt-1">Book {{ selectedBook.book_number }}</h3>
                    <div class="btb-hero-meta mal-text" v-if="selectedBook.holder_name">
                        <ion-icon name="person-outline"></ion-icon> {{ selectedBook.holder_name }}
                    </div>
                </div>
            </div>

            <div class="section pt-0 mt-2">
                <div class="btb-card">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="mal-text fw-bold">രസീത് ലീഫുകൾ</span>
                        <button type="button" class="btn btn-sm btn-outline-primary" @click="openAddModal">
                            <ion-icon name="add-outline"></ion-icon> Add
                        </button>
                    </div>

                    <div class="text-center py-3" v-if="leavesLoading">
                        <div class="spinner-border spinner-border-sm text-primary"></div>
                    </div>

                    <div class="btb-empty mal-text" v-else-if="!leaves.length">
                        ഈ ബുക്കിൽ ലീഫുകളൊന്നും കണ്ടെത്തിയില്ല.
                    </div>

                    <div class="btb-leaf-row" v-for="(leaf, index) in leaves" :key="leaf.id"
                        :class="{ verified: leaf.verified }">
                        <div class="btb-leaf-order">
                            <button type="button" class="btb-order-btn" :disabled="index === 0"
                                @click="moveLeaf(leaf, 'up')">
                                <ion-icon name="chevron-up-outline"></ion-icon>
                            </button>
                            <span>{{ leaf.serial_no }}</span>
                            <button type="button" class="btb-order-btn" :disabled="index === leaves.length - 1"
                                @click="moveLeaf(leaf, 'down')">
                                <ion-icon name="chevron-down-outline"></ion-icon>
                            </button>
                        </div>
                        <div class="btb-leaf-info">
                            <div class="btb-leaf-top">
                                <span class="btb-leaf-no">#{{ leaf.leaf_number }}</span>
                                <span class="btb-source-badge" :class="'btb-source-' + (leaf.source_label || 'manual')">
                                    {{ sourceLabelText(leaf.source_label) }}
                                </span>
                            </div>
                            <div class="btb-leaf-bottom">
                                <span>{{ leaf.name || '—' }}</span>
                                <span class="fw-bold">₹{{ leaf.amount.toFixed(0) }}</span>
                            </div>
                        </div>
                        <div class="btb-leaf-actions">
                            <button type="button" class="btb-icon-btn" title="Edit" @click="openEditModal(leaf)">
                                <ion-icon name="pencil-outline"></ion-icon>
                            </button>
                            <button type="button" class="btb-verify-btn" :class="{ on: leaf.verified }"
                                @click="toggleVerify(leaf)">
                                <ion-icon name="checkmark-outline"></ion-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section pt-0 mt-2 pb-2" v-if="!leavesLoading">
                <button type="button" class="btn btn-primary btn-block btn-lg" @click="continueToLastLeaf">
                    തുടരുക
                </button>
            </div>
        </template>

        <!-- Step 4: Mark + verify the last written receipt leaf -->
        <template v-if="step === 'last-leaf'">
            <div class="section pt-2">
                <div class="btb-hero">
                    <a href="javascript:void(0)" class="btb-back-link" @click="step = 'verify-leaves'">
                        <ion-icon name="chevron-back-outline"></ion-icon> ലീഫ് ലിസ്റ്റ്
                    </a>
                    <h3 class="btb-hero-title mal-text mt-1">അവസാനം എഴുതിയ രസീത്</h3>
                </div>
            </div>
            <div class="section pt-0 mt-2">
                <div class="btb-card">
                    <div class="form-group basic">
                        <label class="btb-field-label">Last Leaf Number</label>
                        <div class="input-wrapper">
                            <select class="form-select" v-model="lastLeafNumber">
                                <option value="">---Select---</option>
                                <option v-for="n in bookFullRange" :key="n" :value="n">{{ n }}</option>
                            </select>
                        </div>
                    </div>
                    <label class="btb-agree-row">
                        <input type="checkbox" v-model="lastLeafVerified" />
                        <span class="mal-text">ഈ നമ്പർ ശരിയാണെന്ന് ഞാൻ ഉറപ്പുവരുത്തി</span>
                    </label>
                    <button type="button" class="btn btn-primary btn-block btn-lg mt-3"
                        :disabled="!lastLeafNumber || !lastLeafVerified || savingLastLeaf" @click="saveLastLeaf">
                        <span v-show="savingLastLeaf" class="spinner-border spinner-border-sm me-1"></span>
                        തുടരുക
                    </button>
                </div>
            </div>
        </template>

        <!-- Step 5: Consolidation Report — Close only, does not submit -->
        <template v-if="step === 'consolidation'">
            <div class="section pt-2">
                <div class="btb-hero">
                    <h3 class="btb-hero-title mal-text">കൺസോളിഡേഷൻ റിപ്പോർട്ട്</h3>
                </div>
            </div>
            <div class="section pt-0 mt-2" v-if="consolidationLoading">
                <div class="text-center py-3">
                    <div class="spinner-border spinner-border-sm text-primary"></div>
                </div>
            </div>
            <div class="section pt-0 mt-2" v-else-if="consolidation">
                <div class="consolidation-card">
                    <div class="cons-header" @click="consOpen = !consOpen">
                        <span class="cons-title">Consolidation Report</span>
                        <ion-icon name="chevron-down-outline" class="cons-chevron" :class="{ open: consOpen }"></ion-icon>
                    </div>
                    <transition name="cons-collapse">
                        <div v-show="consOpen" class="cons-body">
                            <div class="cons-row">
                                <span class="cons-label mal-text"><ion-icon name="globe-outline" style="color:#16a34a;"></ion-icon> ഓൺലൈൻ പേയ്മെന്റ്</span>
                                <span class="cons-val">₹{{ consolidation.book_totals.online.toFixed(0) }}</span>
                            </div>
                            <div class="cons-row">
                                <span class="cons-label mal-text"><ion-icon name="business-outline" style="color:#b45309;"></ion-icon> QR / ഓഫീസ് (വെരിഫൈഡ്)</span>
                                <span class="cons-val">₹{{ consolidation.book_totals.office.toFixed(0) }}</span>
                            </div>
                            <div class="cons-row">
                                <span class="cons-label mal-text"><ion-icon name="create-outline" style="color:#6c3483;"></ion-icon> മാനുവൽ</span>
                                <span class="cons-val">₹{{ consolidation.book_totals.manual.toFixed(0) }}</span>
                            </div>
                            <div class="cons-row cons-row-total">
                                <span class="cons-label mal-text"><ion-icon name="wallet-outline" style="color:#1a418c;"></ion-icon> ആകെ</span>
                                <span class="cons-val">₹{{ consolidation.book_totals.total.toFixed(0) }}</span>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="btb-notice mal-text mt-2">
                    ലീഫുകൾ: {{ consolidation.book_totals.leaves_count }} · വെരിഫൈ ചെയ്തത്: {{ consolidation.book_totals.verified_count }}
                </div>
                <button type="button" class="btn btn-primary btn-block btn-lg mt-3" @click="closeConsolidation">
                    Close
                </button>
            </div>
        </template>

        <!-- Step 6: Review & final Save/Submit -->
        <template v-if="step === 'review-submit'">
            <div class="section pt-2">
                <div class="btb-hero">
                    <h3 class="btb-hero-title mal-text">സേവ് & സബ്മിറ്റ്</h3>
                    <div class="btb-hero-meta mal-text">എല്ലാ വിവരങ്ങളും ഉറപ്പുവരുത്തിയ ശേഷം സബ്മിറ്റ് ചെയ്യുക.</div>
                </div>
            </div>
            <div class="section pt-0 mt-2">
                <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="submitting"
                    @click="submitTakeback">
                    <span v-show="submitting" class="spinner-border spinner-border-sm me-1"></span>
                    സേവ് ചെയ്ത് സമർപ്പിക്കുക
                </button>
            </div>
        </template>

        <!-- Step 7: Done — download Receipt Consolidation / Branch Consolidation reports.
             Also reused read-only for a book that was already completed in an earlier
             session (tapping it in the book list jumps straight here). -->
        <template v-if="step === 'done'">
            <div class="section pt-2">
                <div class="btb-hero">
                    <a href="javascript:void(0)" class="btb-back-link" v-if="viewingCompleted" @click="backToBooks">
                        <ion-icon name="chevron-back-outline"></ion-icon> ബുക്ക് ലിസ്റ്റ്
                    </a>
                    <div class="btb-hero-icon" :style="{ color: viewingCompleted ? '#1a418c' : '#1DCC70' }">
                        <ion-icon :name="viewingCompleted ? 'document-text-outline' : 'checkmark-circle-outline'"></ion-icon>
                    </div>
                    <h3 class="btb-hero-title mal-text">
                        {{ viewingCompleted ? 'രസീത് കൺസോളിഡേഷൻ' : 'ബുക്ക് വിജയകരമായി തിരിച്ചെടുത്തു' }}
                    </h3>
                </div>
            </div>

            <div class="section pt-0 mt-2" v-if="consolidation">
                <div class="consolidation-card" ref="receiptCard">
                    <div class="cons-header cons-header-static">
                        <span class="cons-title">രസീത് കൺസോളിഡേഷൻ — Book {{ selectedBook.book_number }}</span>
                    </div>
                    <div class="cons-body">
                        <div class="cons-row">
                            <span class="cons-label mal-text"><ion-icon name="globe-outline" style="color:#16a34a;"></ion-icon> ഓൺലൈൻ പേയ്മെന്റ്</span>
                            <span class="cons-val">₹{{ consolidation.book_totals.online.toFixed(0) }}</span>
                        </div>
                        <div class="cons-row">
                            <span class="cons-label mal-text"><ion-icon name="business-outline" style="color:#b45309;"></ion-icon> QR / ഓഫീസ് (വെരിഫൈഡ്)</span>
                            <span class="cons-val">₹{{ consolidation.book_totals.office.toFixed(0) }}</span>
                        </div>
                        <div class="cons-row">
                            <span class="cons-label mal-text"><ion-icon name="create-outline" style="color:#6c3483;"></ion-icon> മാനുവൽ</span>
                            <span class="cons-val">₹{{ consolidation.book_totals.manual.toFixed(0) }}</span>
                        </div>
                        <div class="cons-row cons-row-total">
                            <span class="cons-label mal-text"><ion-icon name="wallet-outline" style="color:#1a418c;"></ion-icon> ആകെ</span>
                            <span class="cons-val">₹{{ consolidation.book_totals.total.toFixed(0) }}</span>
                        </div>
                    </div>
                </div>
                <div class="btb-dl-row">
                    <button type="button" class="btb-dl-btn" :disabled="downloadingReceiptPdf"
                        @click="downloadReceiptConsolidationPdf">
                        <ion-icon name="document-outline"></ion-icon> PDF
                    </button>
                    <button type="button" class="btb-dl-btn" :disabled="downloadingReceiptImage"
                        @click="downloadReceiptConsolidationImage">
                        <ion-icon name="image-outline"></ion-icon> Image
                    </button>
                </div>
            </div>

            <div class="section pt-0 mt-3" v-if="consolidation">
                <div class="consolidation-card consolidation-card-branch" ref="branchCard">
                    <div class="cons-header cons-header-static">
                        <span class="cons-title">ശാഖാ കൺസോളിഡേഷൻ — {{ context.unit ? context.unit.name : '' }}</span>
                    </div>
                    <div class="cons-body">
                        <div class="cons-row">
                            <span class="cons-label mal-text"><ion-icon name="globe-outline" style="color:#16a34a;"></ion-icon> ഓൺലൈൻ പേയ്മെന്റ്</span>
                            <span class="cons-val">₹{{ consolidation.unit_totals.online.toFixed(0) }}</span>
                        </div>
                        <div class="cons-row">
                            <span class="cons-label mal-text"><ion-icon name="business-outline" style="color:#b45309;"></ion-icon> QR / ഓഫീസ് (വെരിഫൈഡ്)</span>
                            <span class="cons-val">₹{{ consolidation.unit_totals.office.toFixed(0) }}</span>
                        </div>
                        <div class="cons-row">
                            <span class="cons-label mal-text"><ion-icon name="create-outline" style="color:#6c3483;"></ion-icon> മാനുവൽ</span>
                            <span class="cons-val">₹{{ consolidation.unit_totals.manual.toFixed(0) }}</span>
                        </div>
                        <div class="cons-row cons-row-total">
                            <span class="cons-label mal-text"><ion-icon name="wallet-outline" style="color:#1a418c;"></ion-icon> ആകെ</span>
                            <span class="cons-val">₹{{ consolidation.unit_totals.total.toFixed(0) }}</span>
                        </div>
                    </div>
                </div>
                <div class="btb-dl-row">
                    <button type="button" class="btb-dl-btn" :disabled="downloadingBranchPdf"
                        @click="downloadBranchConsolidationPdf">
                        <ion-icon name="document-outline"></ion-icon> PDF
                    </button>
                    <button type="button" class="btb-dl-btn" :disabled="downloadingBranchImage"
                        @click="downloadBranchConsolidationImage">
                        <ion-icon name="image-outline"></ion-icon> Image
                    </button>
                </div>
            </div>

            <div class="section pt-0 mt-3 pb-4">
                <button type="button" class="btn btn-primary btn-block btn-lg" @click="backToBooks">
                    ബുക്ക് ലിസ്റ്റിലേക്ക്
                </button>
            </div>
        </template>
    </template>

    <!-- Edit leaf modal -->
    <div class="modal fade action-sheet" id="editLeafModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Edit Leaf</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <label class="btb-field-label">Leaf Number</label>
                            <div class="input-wrapper">
                                <select class="form-select" v-model="editLeaf.leaf_number">
                                    <option v-for="n in editLeafNumberOptions" :key="n" :value="n">{{ n }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <label class="btb-field-label">Name</label>
                            <div class="input-wrapper">
                                <input type="text" class="form-control" v-model="editLeaf.name" />
                            </div>
                        </div>
                        <div class="form-group basic">
                            <label class="btb-field-label">Amount</label>
                            <div class="input-wrapper">
                                <input type="number" class="form-control" v-model="editLeaf.amount" />
                            </div>
                        </div>
                        <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="savingLeaf"
                            @click="saveEdit">
                            <span v-show="savingLeaf" class="spinner-border spinner-border-sm me-1"></span>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Add leaf modal -->
    <div class="modal fade action-sheet" id="addLeafModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Add Missing Leaf</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <label class="btb-field-label">Leaf Number</label>
                            <div class="input-wrapper">
                                <select class="form-select" v-model="addLeafForm.leaf_number" :disabled="availableNumbersLoading">
                                    <option value="">---Select---</option>
                                    <option v-for="n in availableNumbers" :key="n" :value="n">{{ n }}</option>
                                </select>
                            </div>
                            <div v-if="availableNumbersLoading" class="text-center py-2">
                                <div class="spinner-border spinner-border-sm text-secondary"></div>
                            </div>
                            <p class="error-feedback mt-1" v-else-if="!availableNumbers.length">
                                No available receipt numbers found for this book.
                            </p>
                        </div>
                        <div class="form-group basic">
                            <label class="btb-field-label">Name</label>
                            <div class="input-wrapper">
                                <input type="text" class="form-control" v-model="addLeafForm.name" />
                            </div>
                        </div>
                        <div class="form-group basic">
                            <label class="btb-field-label">Amount</label>
                            <div class="input-wrapper">
                                <input type="number" class="form-control" v-model="addLeafForm.amount" />
                            </div>
                        </div>
                        <button type="button" class="btn btn-primary btn-block btn-lg"
                            :disabled="savingLeaf || !addLeafForm.leaf_number" @click="saveAdd">
                            <span v-show="savingLeaf" class="spinner-border spinner-border-sm me-1"></span>
                            Add
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import $ from "jquery";
import UserService from "@/services/user.service";
import AlertModel from "../layouts/AlertModel.vue";

// Fixed 8-question Unit Accounts Inspection checklist (spec keys a-h) — not admin-configurable,
// unlike the take-back instructions text, so kept as a plain constant.
const INSPECTION_QUESTIONS = [
    { key: "a", label: "യൂണിറ്റിൽ Accounts book ഉണ്ടോ?" },
    { key: "b", label: "Book കൃത്യമായി എഴുതുന്നുണ്ടോ?" },
    { key: "c", label: "ഓരോ മാസവും ബാലൻസ് ചെയ്ത് സെക്രട്ടറി / പ്രസിഡന്റ് ഒപ്പ് വെച്ചിട്ടുണ്ടോ?" },
    { key: "d", label: "സംഭാവനകൾക്ക് Receipt നൽകിയിട്ടുണ്ടോ?" },
    { key: "e", label: "Income Expense Voucher സൂക്ഷിച്ചിട്ടുണ്ടോ?" },
    { key: "f", label: "ബില്ലുകൾ Voucher-മായി ഒട്ടിച്ചു ചേർത്ത് വെച്ചിട്ടുണ്ടോ?" },
    { key: "g", label: "ഫണ്ടിൽ നിന്നും ലഭിച്ച പണം അതത് ആവശ്യത്തിന് മാത്രമാണോ ഉപയോഗിച്ചത്?" },
    { key: "h", label: "Receivables and Payables രേഖപ്പെടുത്തി വെച്ചിട്ടുണ്ടോ?" },
];

export default {
    name: "BookTakeBack",
    components: { AlertModel },
    data() {
        return {
            loading: true,
            step: "instructions",
            fundType: null,
            year: new Date().getFullYear(),
            subLevel: null,
            zoneId: null,
            unitId: null,

            instructions: "",
            showOnce: false,
            acknowledged: false,
            agreeChecked: false,

            // Youth Dawa Fund settlement report + Share Taken / Request Share Fund (unit only)
            settlementSheet: null,
            shareTakenSaving: false,
            requestShareAmount: '',
            requestShareReason: '',
            requestShareSaving: false,
            requestShareMsg: '',
            requestSharePaymentMethod: 'upi',
            requestShareUpiId: '',
            requestShareGpayMobile: '',
            requestShareGpayName: '',
            requestShareAccountHolderName: '',
            requestShareAccountNumber: '',
            requestShareIfscCode: '',
            myShareRequests: [],
            receivingSaving: false,
            viewingProofUrl: null,

            units: [],
            unitsLoading: false,

            inspectionQuestions: INSPECTION_QUESTIONS,
            inspectionAnswers: { a: null, b: null, c: null, d: null, e: null, f: null, g: null, h: null },
            inspectionLoading: false,
            savingInspection: false,

            context: { district: null, zone: null, unit: null },
            books: [],
            selectedBook: null,
            viewingCompleted: false,

            leaves: [],
            leavesLoading: false,
            savingLeaf: false,

            editLeaf: { id: null, name: "", amount: "", leaf_number: "" },
            addLeafForm: { leaf_number: "", name: "", amount: "" },
            availableNumbers: [],
            availableNumbersLoading: false,

            lastLeafNumber: "",
            lastLeafVerified: false,
            savingLastLeaf: false,

            consolidation: null,
            consolidationLoading: false,
            consOpen: true,
            submitting: false,

            downloadingReceiptPdf: false,
            downloadingBranchPdf: false,
            downloadingReceiptImage: false,
            downloadingBranchImage: false,

            alert_type: "",
            alert_message: "",
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        // Entered from the zone report's single button (sub_level != 4) -> pick a unit first.
        // Entered directly from a unit's own page (sub_level == 4) -> unit is already known.
        needsUnitSelection() {
            return this.subLevel !== 4;
        },
        // The Share Taken / Request Share Fund action only makes sense once every receipt book
        // has actually been verified and taken back — before that, the unit's cash figures
        // aren't final yet.
        allBooksVerified() {
            return this.books.length > 0 && this.books.every((b) => !!b.taken_back_at);
        },
        // Most recent Request Share Fund submission (list already comes back id-descending).
        latestShareRequest() {
            return this.myShareRequests.length ? this.myShareRequests[0] : null;
        },
        // Once Zone approves a request AND the unit confirms the money arrived, the shortfall is
        // resolved in practice even though the raw FundCollection cash figures don't reflect an
        // internal Zone->Unit transfer — treat it the same as "cash is now sufficient".
        moneyEffectivelyReceived() {
            const r = this.latestShareRequest;
            return !!(r && r.status === 'approved' && r.received_status === 'received');
        },
        // Every leaf number in the selected book's range, for the Edit dropdown — the admin may
        // reassign to any number in the book, not just currently-unused ones.
        bookFullRange() {
            if (!this.selectedBook || !this.selectedBook.receipt_from || !this.selectedBook.receipt_to) return [];
            const from = parseInt(this.selectedBook.receipt_from, 10);
            const to = parseInt(this.selectedBook.receipt_to, 10);
            const arr = [];
            for (let n = from; n <= to; n++) arr.push(String(n));
            return arr;
        },
        // The current leaf's own number might not be a plain in-range number (e.g. an office
        // "T..." placeholder) — always include it so the select never shows blank.
        editLeafNumberOptions() {
            const opts = [...this.bookFullRange];
            const current = String(this.editLeaf.leaf_number || "");
            if (current && !opts.includes(current)) {
                opts.unshift(current);
            }
            return opts;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
            return;
        }
        this.$root.updateParent("ബുക്ക് തിരിച്ചെടുക്കൽ");
        this.fundType = parseInt(this.$route.params.type, 10);
        this.subLevel = parseInt(this.$route.params.sub_level, 10);
        if (this.subLevel === 4) {
            this.unitId = parseInt(this.$route.params.id, 10);
            this.loadSettlementSheet();
            this.loadMySubmittedShareRequests();
        } else {
            this.zoneId = parseInt(this.$route.params.id, 10);
        }
        this.loadInstructions();
    },
    methods: {
        sourceLabelText(source) {
            const map = { online: "🌐 Online", office: "Office Verified", manual: "Manual", karad: "Karad", ffr: "FFR" };
            return map[source] || "Manual";
        },
        showAlert(type, message) {
            this.alert_type = type;
            this.alert_message = message;
            this.$refs.alert_model.openModel();
        },
        loadInstructions() {
            this.loading = true;
            UserService.authPostRequest("receipt-book/take-back/get-instructions", {}).then((response) => {
                this.loading = false;
                if (response.data.status === "success") {
                    const data = response.data.data;
                    this.instructions = data.instructions || "";
                    this.showOnce = !!data.show_once;
                    this.acknowledged = !!data.acknowledged;
                    if (this.showOnce && this.acknowledged) {
                        this.proceedPastInstructions();
                    } else {
                        this.step = "instructions";
                    }
                }
            }).catch(() => { this.loading = false; });
        },
        formatAmt(v) {
            const n = parseFloat(v || 0);
            return n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        isPdfUrl(url) {
            return String(url).toLowerCase().indexOf('.pdf') !== -1;
        },
        openProofView(url) {
            this.viewingProofUrl = url;
            $('#proofViewModal').modal('show');
        },
        loadSettlementSheet() {
            UserService.authPostRequest('get-fund-collection-settlement-sheet', {
                user_level: 4,
                user_level_id: this.unitId,
                type: this.fundType,
            }).then((response) => {
                if (response.data.status === 'success') {
                    this.settlementSheet = response.data.data;
                }
            }).catch(() => {});
        },
        loadMySubmittedShareRequests() {
            UserService.authPostRequest('get-my-submitted-share-requests', {
                requesting_level: 4,
                requesting_level_id: this.unitId,
                type: this.fundType,
            }).then((response) => {
                if (response.data.status === 'success') {
                    this.myShareRequests = response.data.data.requests || [];
                }
            }).catch(() => {});
        },
        markReceivedAction(received) {
            if (!this.latestShareRequest) return;
            this.receivingSaving = true;
            UserService.authPostRequest('mark-share-request-received', {
                id: this.latestShareRequest.id,
                received,
            }).then(
                (response) => {
                    this.receivingSaving = false;
                    if (response.data.status === 'success') {
                        this.loadMySubmittedShareRequests();
                        this.loadSettlementSheet();
                    } else {
                        this.showAlert('Warning', response.data.message);
                    }
                },
                (error) => {
                    this.receivingSaving = false;
                    this.showAlert('Warning', (error.response && error.response.data && error.response.data.message) || error.message || error.toString());
                }
            );
        },
        markShareTakenAction() {
            this.shareTakenSaving = true;
            UserService.authPostRequest('mark-share-taken', {
                user_level: 4,
                user_level_id: this.unitId,
                type: this.fundType,
            }).then(
                (response) => {
                    this.shareTakenSaving = false;
                    if (response.data.status === 'success') {
                        this.loadSettlementSheet();
                    } else {
                        this.showAlert('Warning', response.data.message);
                    }
                },
                (error) => {
                    this.shareTakenSaving = false;
                    this.showAlert('Warning', (error.response && error.response.data && error.response.data.message) || error.message || error.toString());
                }
            );
        },
        openRequestShareModal() {
            this.requestShareAmount = this.settlementSheet && this.settlementSheet.shortfall > 0
                ? this.settlementSheet.shortfall.toFixed(2)
                : '';
            this.requestShareReason = '';
            this.requestShareMsg = '';
            this.requestSharePaymentMethod = 'upi';
            this.requestShareUpiId = '';
            this.requestShareGpayMobile = '';
            this.requestShareGpayName = '';
            this.requestShareAccountHolderName = '';
            this.requestShareAccountNumber = '';
            this.requestShareIfscCode = '';
            $('#requestShareFundModal').modal('show');
        },
        submitShareFundRequest() {
            const amount = parseFloat(this.requestShareAmount);
            if (!amount || amount <= 0) {
                this.requestShareMsg = 'സാധുവായ തുക നൽകുക.';
                return;
            }
            if (this.requestSharePaymentMethod === 'upi' && !this.requestShareUpiId.trim()
                && (!this.requestShareGpayMobile.trim() || !this.requestShareGpayName.trim())) {
                this.requestShareMsg = 'UPI ഐഡി അല്ലെങ്കിൽ ഗൂഗിൾ പേ നമ്പറും പേരും നൽകുക.';
                return;
            }
            if (this.requestSharePaymentMethod === 'bank'
                && (!this.requestShareAccountHolderName.trim() || !this.requestShareAccountNumber.trim() || !this.requestShareIfscCode.trim())) {
                this.requestShareMsg = 'അക്കൗണ്ട് വിവരങ്ങൾ പൂർണ്ണമായി നൽകുക.';
                return;
            }
            this.requestShareSaving = true;
            this.requestShareMsg = '';
            UserService.authPostRequest('request-share-fund-from-state', {
                requesting_level: 4,
                requesting_level_id: this.unitId,
                type: this.fundType,
                amount,
                reason: this.requestShareReason,
                payment_method: this.requestSharePaymentMethod,
                upi_id: this.requestShareUpiId,
                gpay_mobile: this.requestShareGpayMobile,
                gpay_account_holder_name: this.requestShareGpayName,
                account_holder_name: this.requestShareAccountHolderName,
                account_number: this.requestShareAccountNumber,
                ifsc_code: this.requestShareIfscCode,
            }).then(
                (response) => {
                    this.requestShareSaving = false;
                    if (response.data.status === 'success') {
                        $('#requestShareFundModal').modal('hide');
                        this.showAlert('Success', response.data.message);
                        this.loadMySubmittedShareRequests();
                    } else {
                        this.requestShareMsg = response.data.message;
                    }
                },
                (error) => {
                    this.requestShareSaving = false;
                    this.requestShareMsg = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                }
            );
        },
        agreeAndContinue() {
            if (!this.agreeChecked) return;
            if (this.showOnce) {
                UserService.authPostRequest("receipt-book/take-back/acknowledge-instructions", {});
            }
            this.proceedPastInstructions();
        },
        proceedPastInstructions() {
            if (this.needsUnitSelection) {
                this.step = "select-unit";
                this.loadZoneUnits();
            } else {
                this.goToUnitInspection();
            }
        },
        loadZoneUnits() {
            this.unitsLoading = true;
            UserService.authPostRequest("receipt-book/take-back/get-zone-units", {
                zone_id: this.zoneId,
                fund_type: this.fundType,
                year: this.year,
            }).then((response) => {
                this.unitsLoading = false;
                if (response.data.status === "success") {
                    this.units = response.data.data.units || [];
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch((error) => {
                this.unitsLoading = false;
                this.showAlert("Error", (error.response && error.response.data && error.response.data.message) || "ഡാറ്റ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല");
            });
        },
        selectUnit(unit) {
            this.unitId = unit.id;
            this.goToUnitInspection();
        },
        backToUnits() {
            this.step = "select-unit";
            this.selectedBook = null;
            this.books = [];
        },
        goToUnitInspection() {
            this.step = "unit-inspection";
            this.loadContext();
            this.loadUnitInspection();
        },
        loadUnitInspection() {
            this.inspectionLoading = true;
            UserService.authPostRequest("receipt-book/take-back/get-unit-inspection", {
                unit_id: this.unitId,
                fund_type: this.fundType,
                year: this.year,
            }).then((response) => {
                this.inspectionLoading = false;
                if (response.data.status === "success") {
                    const saved = response.data.data.answers || {};
                    this.inspectionQuestions.forEach((q) => {
                        this.inspectionAnswers[q.key] = Object.prototype.hasOwnProperty.call(saved, q.key)
                            ? !!saved[q.key]
                            : null;
                    });
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch((error) => {
                this.inspectionLoading = false;
                this.showAlert("Error", (error.response && error.response.data && error.response.data.message) || "ഡാറ്റ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല");
            });
        },
        continueFromInspection() {
            const unanswered = this.inspectionQuestions.some((q) => this.inspectionAnswers[q.key] === null);
            if (unanswered) {
                this.showAlert("Warning", "എല്ലാ ചോദ്യങ്ങൾക്കും ഉത്തരം നൽകുക.");
                return;
            }
            this.savingInspection = true;
            UserService.authPostRequest("receipt-book/take-back/save-unit-inspection", {
                unit_id: this.unitId,
                fund_type: this.fundType,
                year: this.year,
                answers: this.inspectionAnswers,
            }).then((response) => {
                this.savingInspection = false;
                if (response.data.status === "success") {
                    this.step = "select-book";
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch((error) => {
                this.savingInspection = false;
                this.showAlert("Error", (error.response && error.response.data && error.response.data.message) || "സേവ് ചെയ്യാൻ കഴിഞ്ഞില്ല");
            });
        },
        loadContext() {
            this.loading = true;
            UserService.authPostRequest("receipt-book/take-back/get-context", {
                unit_id: this.unitId,
                fund_type: this.fundType,
                year: this.year,
            }).then((response) => {
                this.loading = false;
                if (response.data.status === "success") {
                    const data = response.data.data;
                    this.context = { district: data.district, zone: data.zone, unit: data.unit };
                    this.books = data.books || [];
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch((error) => {
                this.loading = false;
                this.showAlert("Error", (error.response && error.response.data && error.response.data.message) || "ഡാറ്റ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല");
            });
        },
        onBookTileClick(book) {
            if (book.taken_back_at) {
                this.viewCompletedBook(book);
            } else {
                this.selectBook(book);
            }
        },
        selectBook(book) {
            this.selectedBook = book;
        },
        // Already taken back in an earlier session — no need to re-verify leaves/last-leaf/
        // submit again, just show its Receipt/Branch Consolidation report read-only.
        viewCompletedBook(book) {
            this.selectedBook = book;
            this.viewingCompleted = true;
            this.loading = true;
            UserService.authPostRequest("receipt-book/take-back/consolidation", {
                book_id: book.id,
            }).then((response) => {
                this.loading = false;
                if (response.data.status === "success") {
                    this.consolidation = response.data.data;
                    this.step = "done";
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch((error) => {
                this.loading = false;
                this.showAlert("Error", (error.response && error.response.data && error.response.data.message) || "ഡാറ്റ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല");
            });
        },
        loadLeaves() {
            if (!this.selectedBook) return;
            this.leavesLoading = true;
            UserService.authPostRequest("receipt-book/take-back/get-leaves", {
                book_id: this.selectedBook.id,
            }).then((response) => {
                this.leavesLoading = false;
                if (response.data.status === "success") {
                    this.leaves = response.data.data.leaves || [];
                    this.step = "verify-leaves";
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch((error) => {
                this.leavesLoading = false;
                this.showAlert("Error", (error.response && error.response.data && error.response.data.message) || "ഡാറ്റ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല");
            });
        },
        backToBooks() {
            this.step = "select-book";
            this.leaves = [];
            this.consolidation = null;
            this.viewingCompleted = false;
        },
        continueToLastLeaf() {
            this.step = "last-leaf";
            this.lastLeafNumber = this.selectedBook.last_leaf_number || "";
            this.lastLeafVerified = !!this.selectedBook.last_leaf_verified;
        },
        saveLastLeaf() {
            if (!this.lastLeafNumber || !this.lastLeafVerified) return;
            this.savingLastLeaf = true;
            UserService.authPostRequest("receipt-book/take-back/mark-last-leaf", {
                book_id: this.selectedBook.id,
                last_leaf_number: this.lastLeafNumber,
                verified: this.lastLeafVerified,
            }).then((response) => {
                this.savingLastLeaf = false;
                if (response.data.status === "success") {
                    this.selectedBook.last_leaf_number = this.lastLeafNumber;
                    this.selectedBook.last_leaf_verified = this.lastLeafVerified;
                    this.loadConsolidation();
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch(() => { this.savingLastLeaf = false; });
        },
        loadConsolidation() {
            this.step = "consolidation";
            this.consolidationLoading = true;
            UserService.authPostRequest("receipt-book/take-back/consolidation", {
                book_id: this.selectedBook.id,
            }).then((response) => {
                this.consolidationLoading = false;
                if (response.data.status === "success") {
                    this.consolidation = response.data.data;
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch((error) => {
                this.consolidationLoading = false;
                this.showAlert("Error", (error.response && error.response.data && error.response.data.message) || "ഡാറ്റ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല");
            });
        },
        closeConsolidation() {
            // "Close" only dismisses the report view — the actual submit is a separate,
            // deliberate step (spec: Consolidation Report has no direct submit action).
            this.step = "review-submit";
        },
        submitTakeback() {
            this.submitting = true;
            UserService.authPostRequest("receipt-book/take-back/submit", {
                book_id: this.selectedBook.id,
            }).then((response) => {
                this.submitting = false;
                if (response.data.status === "success") {
                    // Same object reference as the matching entry in `books` — mutating it here
                    // marks that tile green immediately if the user goes back to the book list.
                    this.selectedBook.taken_back_at = new Date().toISOString();
                    this.step = "done";
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch((error) => {
                this.submitting = false;
                this.showAlert("Error", (error.response && error.response.data && error.response.data.message) || "സമർപ്പിക്കാൻ കഴിഞ്ഞില്ല");
            });
        },
        downloadBlob(data, filename) {
            const blob = data instanceof Blob ? data : new Blob([data]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        },
        downloadReceiptConsolidationPdf() {
            this.downloadingReceiptPdf = true;
            UserService.authGetRequest("receipt-book/take-back/receipt-consolidation-pdf", {
                book_id: this.selectedBook.id,
            }, { responseType: "blob" }).then((response) => {
                this.downloadingReceiptPdf = false;
                this.downloadBlob(response.data, "receipt-consolidation-book-" + this.selectedBook.book_number + ".pdf");
            }).catch(() => {
                this.downloadingReceiptPdf = false;
                this.showAlert("Error", "ഡൗൺലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല.");
            });
        },
        downloadBranchConsolidationPdf() {
            this.downloadingBranchPdf = true;
            UserService.authGetRequest("receipt-book/take-back/branch-consolidation-pdf", {
                unit_id: this.unitId,
                fund_type: this.fundType,
                year: this.year,
            }, { responseType: "blob" }).then((response) => {
                this.downloadingBranchPdf = false;
                this.downloadBlob(response.data, "branch-consolidation-unit-" + this.unitId + ".pdf");
            }).catch(() => {
                this.downloadingBranchPdf = false;
                this.showAlert("Error", "ഡൗൺലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല.");
            });
        },
        downloadReceiptConsolidationImage() {
            this.downloadingReceiptImage = true;
            import("html2canvas").then(({ default: html2canvas }) => html2canvas(this.$refs.receiptCard, { scale: 2 })).then((canvas) => {
                canvas.toBlob((blob) => {
                    this.downloadingReceiptImage = false;
                    this.downloadBlob(blob, "receipt-consolidation-book-" + this.selectedBook.book_number + ".png");
                }, "image/png");
            }).catch(() => {
                this.downloadingReceiptImage = false;
                this.showAlert("Error", "ഇമേജ് ഉണ്ടാക്കാൻ കഴിഞ്ഞില്ല.");
            });
        },
        downloadBranchConsolidationImage() {
            this.downloadingBranchImage = true;
            import("html2canvas").then(({ default: html2canvas }) => html2canvas(this.$refs.branchCard, { scale: 2 })).then((canvas) => {
                canvas.toBlob((blob) => {
                    this.downloadingBranchImage = false;
                    this.downloadBlob(blob, "branch-consolidation-unit-" + this.unitId + ".png");
                }, "image/png");
            }).catch(() => {
                this.downloadingBranchImage = false;
                this.showAlert("Error", "ഇമേജ് ഉണ്ടാക്കാൻ കഴിഞ്ഞില്ല.");
            });
        },
        toggleVerify(leaf) {
            const newValue = !leaf.verified;
            leaf.verified = newValue;
            UserService.authPostRequest("receipt-book/take-back/verify-leaf", {
                leaf_id: leaf.id,
                verified: newValue,
            }).then((response) => {
                if (response.data.status !== "success") {
                    leaf.verified = !newValue;
                    this.showAlert("Warning", response.data.message);
                }
            }).catch(() => {
                leaf.verified = !newValue;
            });
        },
        moveLeaf(leaf, direction) {
            UserService.authPostRequest("receipt-book/take-back/reorder-leaf", {
                leaf_id: leaf.id,
                direction: direction,
            }).then((response) => {
                if (response.data.status === "success") {
                    this.loadLeaves();
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            });
        },
        openEditModal(leaf) {
            this.editLeaf = {
                id: leaf.id,
                name: leaf.name,
                amount: leaf.amount,
                leaf_number: leaf.leaf_number,
            };
            $("#editLeafModal").modal("show");
        },
        saveEdit() {
            this.savingLeaf = true;
            UserService.authPostRequest("receipt-book/take-back/update-leaf", {
                leaf_id: this.editLeaf.id,
                name: this.editLeaf.name,
                amount: this.editLeaf.amount,
                leaf_number: this.editLeaf.leaf_number,
            }).then((response) => {
                this.savingLeaf = false;
                if (response.data.status === "success") {
                    $("#editLeafModal").modal("hide");
                    this.loadLeaves();
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch(() => { this.savingLeaf = false; });
        },
        openAddModal() {
            this.addLeafForm = { leaf_number: "", name: "", amount: "" };
            this.availableNumbers = [];
            this.availableNumbersLoading = true;
            $("#addLeafModal").modal("show");
            UserService.authPostRequest("receipt-book/available-receipt-numbers", {
                fund_type: this.fundType,
                unit_id: this.unitId,
                year: this.year,
                book_id: this.selectedBook.id,
            }).then((response) => {
                this.availableNumbersLoading = false;
                if (response.data.status === "success") {
                    this.availableNumbers = response.data.data.numbers || [];
                }
            }).catch(() => { this.availableNumbersLoading = false; });
        },
        saveAdd() {
            this.savingLeaf = true;
            UserService.authPostRequest("receipt-book/take-back/add-leaf", {
                book_id: this.selectedBook.id,
                leaf_number: this.addLeafForm.leaf_number,
                name: this.addLeafForm.name,
                amount: this.addLeafForm.amount,
            }).then((response) => {
                this.savingLeaf = false;
                if (response.data.status === "success") {
                    $("#addLeafModal").modal("hide");
                    this.loadLeaves();
                } else {
                    this.showAlert("Warning", response.data.message);
                }
            }).catch((error) => {
                this.savingLeaf = false;
                this.showAlert("Error", (error.response && error.response.data && error.response.data.message) || "സേവ് ചെയ്യാൻ കഴിഞ്ഞില്ല");
            });
        },
    },
};
</script>

<style scoped>
.btb-hero {
    background: #fff;
    border-radius: 14px;
    padding: 18px 16px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.btb-hero-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #eef2ff;
    color: #1a418c;
    font-size: 24px;
    margin-bottom: 8px;
}

.btb-hero-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #1a418c;
}

.btb-hero-meta {
    font-size: 0.85rem;
    color: #6c757d;
    margin-top: 4px;
}

.btb-back-link {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    font-size: 0.85rem;
    color: #1a418c;
    text-decoration: none;
    font-weight: 600;
}

.btb-card {
    background: #fff;
    border-radius: 14px;
    padding: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.btb-instructions {
    font-size: 0.9rem;
    line-height: 1.6;
    color: #27173e;
    margin-bottom: 14px;
    /* The admin portal's instructions text is a plain textarea with a blank line between
       numbered points — rendered here via v-html into a div, so those newlines are collapsed
       by default HTML whitespace rules unless preserved explicitly. */
    white-space: pre-line;
}

.btb-agree-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: #f5f6fa;
    border-radius: 10px;
    cursor: pointer;
    font-size: 0.9rem;
}

.btb-notice {
    background: #f5f6fa;
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 0.85rem;
    color: #495057;
    text-align: center;
}

.btb-notice-warning {
    background: #fff5f5;
    color: #d9534f;
    border: 1px solid #ffd9d9;
}

/* Consolidation Report card — same design as the Collection Report page's card */
.consolidation-card {
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 14px;
    padding: 4px 16px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .04);
}

/* Branch/unit-level card — distinct tint so it reads as a different scope from the
   book-level Receipt Consolidation card above it. */
.consolidation-card-branch {
    background: #f5f3ff;
    border: 1px solid #ddd6fe;
}

.consolidation-card-branch .cons-title {
    color: #5b21b6;
}

/* Youth Dawa Fund settlement report — own tint (amber) to read as a distinct scope. */
.consolidation-card-settlement {
    background: #fffaf0;
    border: 1px solid #fde3b0;
}
.consolidation-card-settlement .cons-title {
    color: #b45309;
}
.ydf-takeback-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 14px;
    padding: 12px 14px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .05);
    text-decoration: none;
    transition: transform .12s ease, box-shadow .12s ease;
    width: 100%;
    text-align: left;
    cursor: pointer;
}
.ydf-takeback-btn:active {
    transform: translateY(1px);
    box-shadow: 0 1px 5px rgba(0, 0, 0, .06);
}
.ydf-takeback-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #eef2ff;
    color: #1a418c;
    font-size: 21px;
}
.ydf-takeback-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}
.ydf-takeback-title {
    font-size: 14px;
    font-weight: 800;
    color: #27173E;
}
.ydf-takeback-desc {
    font-size: 11px;
    color: #6c757d;
    line-height: 1.35;
    margin-top: 2px;
}
.ydf-takeback-chevron {
    flex-shrink: 0;
    font-size: 20px;
    color: #adb5bd;
}
.share-taken-card {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    border-radius: 14px;
    padding: 12px 14px;
}
.share-taken-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #dcfce7;
    color: #16a34a;
    font-size: 21px;
}
.share-taken-card.status-pending {
    background: #fffbeb;
    border-color: #fde68a;
}
.share-taken-card.status-pending .share-taken-icon {
    background: #fef3c7;
    color: #b45309;
}
.share-taken-card.status-rejected {
    background: #fef2f2;
    border-color: #fecaca;
}
.share-taken-card.status-rejected .share-taken-icon {
    background: #fee2e2;
    color: #dc2626;
}
/* Cards that also carry action button(s) stack vertically — the icon+text row on top, full-
   width buttons below, so buttons never get squeezed into the narrow leftover space next to the
   icon on a phone-width screen. */
.share-taken-card-action {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
}
.share-taken-row {
    display: flex;
    align-items: center;
    gap: 12px;
}
.share-taken-actions {
    display: flex;
    gap: 10px;
}
.btn-share-received,
.btn-share-not-received,
.btn-share-retry {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 12px;
    border-radius: 10px;
    font-weight: 700;
    font-size: 13.5px;
    border: 1.5px solid transparent;
    cursor: pointer;
}
.btn-share-received ion-icon,
.btn-share-not-received ion-icon {
    font-size: 17px;
}
.btn-share-received {
    background: #16a34a;
    color: #fff;
}
.btn-share-received:active {
    background: #128a3e;
}
.btn-share-not-received {
    background: #fff;
    color: #dc2626;
    border-color: #fecaca;
}
.btn-share-not-received:active {
    background: #fef2f2;
}
.btn-share-retry {
    background: #fff;
    color: #1a418c;
    border-color: #c7d2fe;
    width: 100%;
}
.btn-share-retry:active {
    background: #eef2ff;
}
.btn-share-received:disabled,
.btn-share-not-received:disabled {
    opacity: .6;
    cursor: not-allowed;
}

.btb-dl-row {
    display: flex;
    gap: 8px;
    margin-top: 8px;
}

.btb-dl-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #1a418c;
    background: #fff;
    color: #1a418c;
    font-weight: 700;
    font-size: 0.9rem;
}

.btb-dl-btn:active {
    background: #eef2ff;
}

.btb-dl-btn:disabled {
    opacity: 0.6;
}

.btb-dl-btn ion-icon {
    font-size: 17px;
}

.cons-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 0;
    cursor: pointer;
    user-select: none;
}

.cons-header-static {
    cursor: default;
}

.cons-title {
    font-size: 13px;
    font-weight: 800;
    color: #27173E;
    letter-spacing: 0.02em;
}

.cons-chevron {
    font-size: 18px;
    color: #94a3b8;
    transition: transform .28s ease;
}

.cons-chevron.open {
    transform: rotate(180deg);
}

.cons-body {
    padding-bottom: 8px;
}

.cons-collapse-enter-active,
.cons-collapse-leave-active {
    transition: max-height .28s ease, opacity .28s ease;
    overflow: hidden;
}

.cons-collapse-enter-from,
.cons-collapse-leave-to {
    max-height: 0;
    opacity: 0;
}

.cons-collapse-enter-to,
.cons-collapse-leave-from {
    max-height: 240px;
    opacity: 1;
}

.cons-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 0;
    border-top: 1px solid #f3f4f8;
}

.cons-row:first-of-type { border-top: none; }

.cons-row-total .cons-label,
.cons-row-total .cons-val {
    font-weight: 900;
}

.cons-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #475569;
    font-weight: 600;
}

.cons-label ion-icon { font-size: 18px; }

.cons-val {
    font-size: 15px;
    font-weight: 800;
    color: #27173E;
}

.btb-book-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.btb-book-tile {
    flex: 1 1 calc(50% - 10px);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 14px 10px;
    border: 1px solid #dee2e6;
    border-radius: 12px;
    background: #fff;
    font-size: 0.85rem;
    color: #495057;
    cursor: pointer;
}

.btb-book-tile ion-icon {
    font-size: 22px;
    color: #1a418c;
}

.btb-book-tile.completed {
    border-color: #12a85a;
    background: #eefbf3;
}

.btb-book-tile.selected {
    border-color: #1a418c;
    background: #eef2ff;
}

.btb-book-no {
    font-weight: 700;
    color: #27173e;
}

.btb-book-range {
    font-size: 0.75rem;
    color: #6c757d;
}

.btb-book-badge {
    font-size: 10px;
    font-weight: 700;
    border-radius: 20px;
    padding: 2px 8px;
    margin-top: 2px;
    white-space: nowrap;
}
.btb-book-badge-done { background: #eafaf1; color: #12a85a; }

.btb-unit-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 4px;
    border-bottom: 1px solid #f0f2f5;
    color: #27173e;
    text-decoration: none;
}

.btb-unit-row:last-child {
    border-bottom: none;
}

.btb-unit-row span:first-child {
    flex: 1;
    font-weight: 600;
}

.btb-unit-books {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 0.8rem;
    color: #6c757d;
}

.btb-unit-chevron {
    color: #adb5bd;
    font-size: 18px;
}

.btb-empty {
    text-align: center;
    padding: 20px 0;
    color: #6c757d;
    font-size: 0.9rem;
}

.btb-insp-row {
    padding: 12px 0;
    border-bottom: 1px solid #f0f2f5;
}

.btb-insp-row:last-child {
    border-bottom: none;
}

.btb-insp-q {
    font-size: 0.88rem;
    color: #27173e;
    line-height: 1.4;
    margin-bottom: 8px;
}

.btb-insp-toggle {
    display: flex;
    gap: 8px;
}

.btb-insp-btn {
    flex: 1;
    padding: 8px;
    border-radius: 10px;
    border: 1px solid #ced4da;
    background: #fff;
    color: #495057;
    font-weight: 600;
    font-size: 0.85rem;
}

.btb-insp-btn.selected {
    border-color: #1DCC70;
    background: #eafaf1;
    color: #12a85a;
}

.btb-insp-btn-no.selected {
    border-color: #d9534f;
    background: #fff5f5;
    color: #d9534f;
}

.btb-leaf-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    border-bottom: 1px solid #f0f2f5;
}

.btb-leaf-row:last-child {
    border-bottom: none;
}

.btb-leaf-row.verified {
    background: #f7fdf9;
}

.btb-leaf-order {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    width: 32px;
    font-size: 0.75rem;
    font-weight: 700;
    color: #6c757d;
}

.btb-order-btn {
    border: none;
    background: none;
    padding: 0;
    color: #1a418c;
    font-size: 16px;
    line-height: 1;
}

.btb-order-btn:disabled {
    color: #ced4da;
}

.btb-leaf-info {
    flex: 1;
    min-width: 0;
}

.btb-leaf-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.btb-leaf-no {
    font-weight: 700;
    color: #27173e;
    font-size: 0.9rem;
}

.btb-source-badge {
    font-size: 0.7rem;
    padding: 2px 8px;
    border-radius: 10px;
    background: #e9ecef;
    color: #495057;
    white-space: nowrap;
}

.btb-source-online {
    background: #eafaf1;
    color: #12a85a;
}

.btb-source-office {
    background: #eef2ff;
    color: #1a418c;
}

.btb-leaf-bottom {
    display: flex;
    justify-content: space-between;
    font-size: 0.85rem;
    color: #495057;
    margin-top: 2px;
}

.btb-leaf-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
}

.btb-icon-btn {
    border: none;
    background: #f5f6fa;
    color: #495057;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btb-verify-btn {
    border: 1px solid #ced4da;
    background: #fff;
    color: #ced4da;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btb-verify-btn.on {
    border-color: #12a85a;
    background: #12a85a;
    color: #fff;
}

.btb-field-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    margin-bottom: 3px;
    display: block;
}
</style>
